/**
 * Guía: Solicitudes.
 *
 * Contenido derivado del capítulo **09** del manual: §0 (es la única pantalla
 * alimentada por un formulario público, y eso condiciona su diseño), §4 (los
 * siete estados) y §4.1 (las reglas del cambio, sobre todo por qué
 * «convertida» no se pone a mano).
 *
 * El manual avisa de que esta pantalla y la de solicitudes de asesores son
 * configuraciones del mismo componente: lo que se explica aquí del embudo, la
 * asignación y las notas vale igual allá.
 */

import type { TourFlow } from '../types';

const LEADS_PATH = '/leads';

export const c09Solicitudes: TourFlow = {
  id: 'admin.leads',
  chapter: '09',
  title: 'Solicitudes de comercios',
  summary:
    'La bandeja comercial: los siete estados del embudo y por qué «convertida» no se marca a mano.',
  href: LEADS_PATH,
  estimatedMin: 3,
  steps: [
    {
      id: 'intro',
      title: 'Comercios que piden entrar',
      body:
        'Son los negocios que rellenaron el formulario del sitio público. Es la única ' +
        'pantalla del panel alimentada desde fuera sin sesión: cualquiera en internet puede ' +
        'crear una fila aquí, y por eso cada solicitud guarda de dónde vino.',
      route: LEADS_PATH,
    },
    {
      id: 'funnel',
      title: 'Siete estados, de nueva a convertida',
      body:
        'Nueva, asignada, contactada, calificada, convertida, rechazada y aplazada. ' +
        'Aplazar exige fecha de seguimiento —sin ella no deja—, y al sacarla de aplazada ' +
        'esa fecha se limpia sola para no dejar un recordatorio fantasma.',
      target: 'admin.leads.table',
      placement: 'top',
      optionalTarget: true,
    },
    {
      id: 'converted-is-special',
      title: '«Convertida» no se marca a mano',
      body:
        'Hay que usar la acción de convertir, y no es un capricho: es la única operación ' +
        'que sabe atar la solicitud a la empresa. Marcarla a mano dejaba solicitudes ' +
        'convertidas sin empresa vinculada, que después no se podían recuperar. Y una ya ' +
        'convertida no vuelve a cambiar de estado.',
    },
    {
      id: 'convert-does-not-create',
      title: 'Convertir no crea la empresa',
      body:
        'La vincula a una que ya existe. El alta de la compañía es otro camino, con su ' +
        'propia aprobación: aquí sólo se registra que este contacto acabó siendo ese ' +
        'comercio.',
    },
    {
      id: 'filters',
      title: 'Buscar y repartir',
      body:
        'Se filtra por estado y se busca por negocio o contacto. Las solicitudes nuevas sin ' +
        'asignar son la cola de trabajo: asignarlas es lo que las saca de ahí.',
      target: 'admin.leads.filters',
      placement: 'bottom',
      optionalTarget: true,
    },
    {
      id: 'same-as-advisors',
      title: 'Las solicitudes de asesores funcionan igual',
      body:
        'Son la misma pantalla con otro contenido: mismo embudo, misma asignación, mismas ' +
        'notas. Lo que aprendas aquí sirve allá.',
    },
  ],
};
